module.exports = {
  home_label: "ホーム",
  sign_in: "サインイン",
  label_sign_rewards: " アヤナリワードにサインインする",
  menu_loyalty_update: "会員情報の更新",
  menu_promotion: "キャンペーン",
  menu_member_benefit: "メンバー特典",
  menu_partner: "パートナー",
  menu_reedem: "引き換える",
  menu_faq: "よくあるご質問",
  menu_contact_us: "お問い合わせ",
  menu_tos: "利用規約",
  menu_privacy: "個人情報保護方針",
  btn_book_now: "今すぐ予約",
  label_login_sosmed: "またはソーシャルメディアを通じてログインする",
  label_remember_me: "ログイン状態を保存する",
  label_forgot_password: "パスワードを忘れた",
  btn_create_account: "新しいアカウントを作成する",
  placeholder_email: "Eメールアドレス",
  placeholder_password: "パスワード",
  logout_label: "サインアウト",
  profile_label: "プロフィール",
  point_label: "ポイント",
  widget_label_arrival: "到着",
  widget_label_departure: "出発",
  widget_label_choose_hotel: "宿泊施設を選ぶ",
  widget_label_room: "ルーム",
  widget_label_adult: "大人",
  widget_label_child: "子供",
  widget_button_cancel: "キャンセル",
  widget_dropdown_hotel_option_choose: "1つお選びください",
  widget_hotel_error: "ホテルをお選びください",
  widget_stay_error: "宿泊日を選択してください",
  become_member: "メンバーになる",
};
